import { z } from 'zod'
import { reportError } from '@mc/next-newrelic'
import { MCCERTS_2805_HUB_VALUE_PROP_FLAG } from './constants'

const valuePropSchema = z.object({
  title: z.string().optional(),
  subtitle: z.string().optional(),
})

const styledCopySchema = z.object({
  copy: z.string(),
  style: z.string().optional(),
})

const textFeatureVariableSchema = z.union([
  z.string(),
  styledCopySchema,
  z.array(styledCopySchema),
])

export const Mccerts2805VariablesSchema = z.object({
  bucketName: z.string().optional(),
  headline: textFeatureVariableSchema.optional(),
  subhead: z.string().optional(),
  value_prop_1: valuePropSchema.optional(),
  value_prop_2: valuePropSchema.optional(),
  value_prop_3: valuePropSchema.optional(),
  value_prop_4: valuePropSchema.optional(),
})

export type Mccerts2805Variables = z.infer<typeof Mccerts2805VariablesSchema>

export const parseMccerts2805Variables = (
  value: unknown,
): Mccerts2805Variables => {
  const parsed = Mccerts2805VariablesSchema.safeParse(value)
  if (!parsed.success) {
    reportError(parsed.error, {
      message: 'Invalid hub value-prop variables format',
      flag: MCCERTS_2805_HUB_VALUE_PROP_FLAG,
      variables: JSON.stringify(value),
    })
    return {}
  }
  return parsed.data
}
